export const __DEBUG__ = true
export const __API_URI__ = 'https://staging-api.basemap.com/api/V1.0'
export const __APP_ID__ = '777632355777451'
export const __API_URI_3__ = 'https://staging-api.basemap.com/api/V3.0'
export const __GOOGLE_MAPS_KEY__ = 'AIzaSyC3cOx382EeNm0asyx_onfHu6xFL_IZpC'
export const __FIREBASE_APIKEY__ = 'AIzaSyDjYm1KREr79ThSLZ2WNdGaaRho5AyUnJQ'
export const __FIREBASE_AUTH_DOMAIN__ = 'basemapaos-dev.firebaseapp.com'
export const __FIREBASE_DATABASE_URL__ = 'https://basemapaos-dev.firebaseio.com'
export const __FIREBASE_PROJECT_ID__ = 'basemapaos-dev'
export const __FIREBASE_STORAGE_BUCKET__ = 'basemapaos-dev.appspot.com'
export const __FIREBASE_MESSAGING_SENDER_ID__ = '48081128939'
export const process_env = { NODE_ENV: 'testing' }
